/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withRouter } from 'react-router';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import tableHead from './tableHead';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import TextBoxRender from '../textBoxRender';
import ViewHistoryComponent from '../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { getSelectedCode, updateDefaultAuditData } from '../../store/actions';
import { update } from 'lodash';

function DefaultUnitType(props) {
  const {
    setUpdateDefaultTable,
    setDefCodeValueData,
    saveClicked,
    setSaveClicked,
    setDisabledSaveCancelBtn,
    fullScreenView,
    setFullScreenView,
    isReadOnly,
    isEnabledByRole,
    resetFlag,
    setResetDefaultUnitTypeFlag
  } = props;


  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const originalDataRef = useRef([]);
  const payload = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.defaultAudit?.data
  );
  const resultSelectedCode = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.selectedCode
  );

  const [dataSet, setDataSet] = useState([]);
  const [spinnerLoader, setspinnerLoader] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const [stopRender, setStopRender] = useState(true);
  // const checkedHandler = (e, cellInfo) => {
  //   setDisabledSaveCancelBtn(false);
  //   const checked = e.target.checked ? 1 : 0;
  //   const { colId } = cellInfo.column;
  //   cellInfo.node.setData({ ...cellInfo.node.data, [colId]: checked });
  //   cellInfo.node.setDataValue(colId, checked, e);
  //   const arr = dataSet;
  //   if (arr[cellInfo.rowIndex]) {
  //     arr[cellInfo.rowIndex].defTestOnInd = checked;
  //     setUpdateDefaultTable(arr);
  //     setDataSet(arr);
  //   }
  // };
  useEffect(() => {
    if (resultSelectedCode) {
      setStopRender(false);
    }
  }, [resultSelectedCode]);
  const checkedHandler = useCallback((e, cellInfo) => {
    e.stopPropagation()
    setDisabledSaveCancelBtn(false);
    const checked = e.target.checked ? 1 : 0;
    const { colId } = cellInfo.column;
  
    cellInfo.node.setDataValue(colId, checked);
    const rowKey = cellInfo?.data?.paramTestIdVO?.defTestUnitTypeCd
    setDataSet((prev)=>{
      const updatedData = prev.map(item=>item?.paramTestIdVO?.defTestUnitTypeCd===rowKey?{...item,defTestOnInd:checked}:item)
      setUpdateDefaultTable(updatedData)
      if(typeof setDefCodeValueData === 'function'){
        setDefCodeValueData()
        setDefCodeValueData(JSON.parse(JSON.stringify(updatedData)))
      }
    
    return updatedData});
    const updatedRowData = {...cellInfo.data,deftestOnInd:checked}
    cellInfo.node.setData(updatedRowData);
  },[setDisabledSaveCancelBtn,setUpdateDefaultTable,setDefCodeValueData])
  const frameworkComponents = {
    checkboxRenderer: (cellInfo) => (
      <>
        <div className='tbl-checkbox frr-display-hidden-checkbox-label'>
          <FormControlLabel
            style={{ display: 'flex', marginTop: '10px' }}
            id={`systemParameter${cellInfo?.rowIndex}`}
            control={<Checkbox color='primary' />}
            checked={
              cellInfo?.data?.defTestOnInd === 1 ||
              cellInfo?.data?.defTestOnInd === '1'
            }
            value={cellInfo.value}
            onChange={(e) => {
              if (e.target.checked !== undefined) {
                checkedHandler(e, cellInfo);
              }
            }}
            disabled={isReadOnly || !isEnabledByRole}
            data-testid='checkBox'
            label={`systemParameter${cellInfo?.rowIndex}`}
          />
        </div>
      </>
    ),
    TextBoxRender: (cellInfo) => (
      <TextBoxRender
        cellInfo={cellInfo}
        disabled={isReadOnly || !isEnabledByRole}
        setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
        onValueChanged={(colId, newValue) => {
          const rowKey = cellInfo?.data?.paramTestIdVO?.defTestUnitTypeCd; // Update state synchronously BEFORE ag-Grid node update
          setDataSet((prev) => {
            const updatedData = prev.map((item) =>
              item?.paramTestIdVO?.defTestUnitTypeCd === rowKey
                ? { ...item, [colId]: newValue }
                : item
            ); // Update parent state in the same tick
            setUpdateDefaultTable(updatedData);
            if (typeof setDefCodeValueData === 'function') {
              setDefCodeValueData(JSON.parse(JSON.stringify(updatedData)));
            }
            return updatedData;
          });
        }}
      />
    ),
  };

  useEffect(() => {
    const data = resultSelectedCode?.UNIT_TYPE_CD?.map((item) => ({
      shortDescription: item.shortDescription,
    }));

    const data2 = dataSet.filter((dataItem, index) => {
      const shortDescription = data?.[index]?.shortDescription;
      if (shortDescription === undefined) {
        return false; // Exclude rows with undefined shortDescription
      }
      dataItem.paramTestIdVO.shortDescription = shortDescription;
      return dataItem.paramTestIdVO.defTestUnitTypeCd.length > 1;
    });

    setDataSet(data2);
    setUpdateDefaultTable(data2);
  }, [resultSelectedCode]);

  useEffect(() => {
    dispatch(
      getSelectedCode({
        codeDomainList: ['UNIT_TYPE_CD'],
      })
    );
  }, []);
  useEffect(() => {
    let isActive = true;
    if (!payload) {
      if (isActive) setspinnerLoader(false);
      return () => {
        isActive = false;
      };
    }
    setspinnerLoader(false);

    const filteredData =
      payload.paramTestVO?.filter((dataItem) => {
        return dataItem.paramTestIdVO.defTestUnitTypeCd.length > 1;
      }) || [];

    const unitTypeShortDescs =
      resultSelectedCode?.UNIT_TYPE_CD?.map((i) => i.shortDescription) || [];

    const merged = filteredData.map((dataItem, index) => ({
      ...dataItem,
      paramTestIdVO: {
        ...dataItem.paramTestIdVO,
        shortDescription:
          unitTypeShortDescs[index] ?? dataItem.paramTestIdVO.shortDescription,
      },
    })); 
    originalDataRef.current = JSON.parse(JSON.stringify(merged || []));
    if (isActive) {
      setDataSet((prev) => {
        if (prev.length === 0) {
          setUpdateDefaultTable(merged);
          return merged;
        }
        return prev;
      });
      setUpdateDefaultTable(merged);
    }
    return () => {
      isActive = false;
    };
  }, [payload, resultSelectedCode]);

  useEffect(() => {
    if (resetFlag) {
      const original = JSON.parse(
        JSON.stringify(originalDataRef.current || [])
      );
      setDataSet(original);
      setUpdateDefaultTable(original);
      setDisabledSaveCancelBtn(true);
      setResetDefaultUnitTypeFlag(false)
    }
  }, [resetFlag]);

  useEffect(() => {
    if (!saveClicked) return
    if (saveClicked) {
     if(typeof setDefCodeValueData === 'function'){
      setDefCodeValueData(JSON.parse(JSON.stringify(dataSet || [])))
     }
     if(dataSet && dataSet.length >0) {
      dispatch(updateDefaultAuditData(JSON.parse(JSON.stringify(dataSet || []))))
     }
     setSaveClicked(false)

   }
  
    
   
  }, [saveClicked,dataSet,dispatch,setDefCodeValueData]);

  const onEditingStopped = useCallback(() => {
    setDisabledSaveCancelBtn(false);
    setUpdateDefaultTable(dataSet);
  });

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.paramTestIdVO;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        DEF_TEST_GROUP_CD: `${selectedRow?.defTestGroupCd}`,
        DEF_TEST_TYPE_CD: `${selectedRow?.defTestTypeCd}`,
        DEF_TEST_UNIT_TYPE_CD: `${selectedRow?.defTestUnitTypeCd}`,
      });
    }
  };

  // useEffect(() => {
  //   if (resultSelectedCode) {
  //     setStopRender(false);
  //   }
  // }, [resultSelectedCode]);
  // useEffect(()=>{
  //   if(saveClicked){
  //     console.log(saveClicked)
  //     // setDefCodeValueData(dataSet)
  //     console.log("dispatchings")
  //     dispatch(updateDefaultAuditData(dataSet))
  //   }
  // },[saveClicked])

  return stopRender ? null : (
    <>
      <Spinner load={spinnerLoader} />
      <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-invoiceThreshold frr-aggrid-ckekbox-invoice defaultUnitTypeAudit'>
        <Grid
          frameworkComponents={frameworkComponents}
          onCellValueChanged={onEditingStopped}
          ref={gridRef}
          rowData={dataSet}
          defaultCol={{ editable: false }}
          columnDefs={tableHead}
          gridHeight={fullScreenView ? '70vh' : null}
          handleFullScreenViewClick={handleFullScreenView}
          rowMultiSelectWithClick={false}
          fullScreenView={fullScreenView}
          data-testid='onEditingStopped'
          exportFile
          animateRows
          sideBar={false}
          fileName='Default Unit Type Audits'
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          onFilterData={false}
          handleViewHistory={handleViewHistory}
        />
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='PARAM_TEST'
          keyValue={keyValue}
        />
      )}
    </>
  );
}
export default withRouter(DefaultUnitType);
